import React, { useState, useEffect } from 'react';
import NavigationArrow from '../../common/navigation-arrow';

const AssessmentNavigation = ({className, to, onClick, type = 'next', isVisible = true, delay = 0}) => {
	const [timer, setTimer] = useState(delay);

	useEffect(() => {
		if (timer > 0) {
			setTimeout(() => {
				setTimer(timer - 1);
			}, 1000);
		}
	});

	if (!isVisible || ('undefined' === typeof onClick && 'undefined' === typeof to)) {
		return null;
	}

	return (
		<div className={'assessment-navigation' + (className ? ' ' + className : '') + ` assessment-navigation-${type}`}>
			{timer ? <p className="navigation-timer">{timer}</p> : <NavigationArrow {...{to, onClick, type}} />}
		</div>
	);
}

export default AssessmentNavigation;
